module.exports = __webpack_public_path__ + "img/team.185725e2.jpg";